import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

export class Events extends Component {
  static displayName = Events.name;

  render() {
    return (
      <div style={{ marginBottom: '60px', marginTop: '40px', textAlign: 'center' }}>
        <Helmet>
          <title>Events - Forsthaus Klaushof</title>
          <meta name="keywords" content="Forsthaus, Klaushof, Forsthaus Klaushof, Bad Kissingen, Jan Kirchhof, Kirchhof, Events, Veranstaltungen" />
          <meta name="language" content="de" />
        </Helmet>
        {/*<h1 style={{ marginBottom: '40px' }}>Events</h1>*/}
        <h2 style={{ marginBottom: '40px' }}>Vergangene Events</h2>
        <h3 style={{ marginBottom: '20px' }}>Taste Night am 6.6.2025</h3>
        <img src="/imgs/tastenight.jpg" alt="Taste Night" style={{ display: 'block', margin: '0 auto', width: '60%', marginBottom: '40px' }}  />
        <p style={{marginBottom: '40px'}}><strong>Sommerfest im Forsthaus Klaushof – Ein Genuss für alle Sinne!</strong><br/> 
          <br/>
          Erleben Sie einen unvergesslichen Sommerabend inmitten der idyllischen Natur des Forsthauses Klaushof! Lassen Sie sich verwöhnen mit erlesenen Weinen an unserer exklusiven Weinbar, genießen Sie meisterhafte Kreationen von unseren Live-Kochstationen und lassen Sie sich von stimmungsvoller Musik begleiten.<br/>
          <br/>
          🍷 Weinbar mit erlesenen Tropfen<br/>
          🍽 Live-Kochstationen<br/>
          🎶 Musik für die perfekte Sommerstimmung<br/>
          <br/>
          Freuen Sie sich auf eine einzigartige Atmosphäre, kulinarische Highlights und geselliges Beisammensein!<br/>
          📍 Forsthaus Klaushof<br/>
          📅 06.06.2025 ab 18:00 Uhr<br/>
          🎟 Sichern Sie sich Ihr Ticket unter info@forsthaus-Klaushof.eu // 0971 78558350 // Forsthaus Klaushof<br/>
          Seien Sie dabei und feiern Sie mit uns den Beginn des Sommers!
          </p>
        <h3 style={{ marginBottom: '20px' }}>Neueröffnung am 2.11.2024</h3>
        <p>Am 2. November öffnet das Restaurant des Forsthof Klaushof in neuem Glanz unter neuer Belegschaft.</p>
      </div>
    );
  }
}
